<template>
  <section>
    <div style="font-weight: 600; font-size: 1.3rem; margin: 1rem 0">變更密碼</div>
    <div class="profile-container" style="margin-bottom: 2rem;">
      <form style="width: 100%;" id="password_change_form">
        <div class="profile-userInfo-details">
          <div class="profile-pw-label">舊密碼:</div>
          <div style="width: 100%; align-self: center;"><input class="profile-field" name="password_old" type="password" style="width:100%"></div>
        </div>
        <div class="profile-userInfo-details">
          <div class="profile-pw-label">新密碼:</div>
          <div style="width: 100%; align-self: center;"><input class="profile-field" name="password_new" type="password" style="width:100%"></div>
        </div>
        <div class="profile-userInfo-details">
          <div class="profile-pw-label">重新輸入新密碼:</div>
          <div style="width: 100%; align-self: center;"><input class="profile-field" name="password_confirm" type="password" style="width:100%"></div>
        </div>
        <div style="float: right;padding-top: 1rem;">
          <el-button type="primary" @click="change_password">提交</el-button>
        </div>
      </form>
    </div>
  </section>
</template>

<style lang="scss" scoped>

.profile-userInfo-details{
  display: flex;
  flex-wrap: wrap;
}

.profile-label{
  flex: 0 0 100px;
  margin: 1rem 0;
}

.profile-pw-label{
  flex: 0 0 150px;
  margin: 1rem 0;
}

.profile-field{
  flex: 1;
  padding: 0 1rem;
}

.profile-container{
  background-color: #f5f5f5;
  padding: 2rem 5rem;
  display: flex;
  justify-content: center;
  border-radius: 2.5rem;
  font-size: 1.2rem;
}

input{
  border-radius: 1rem;
}
input:focus{
  box-shadow: 0 0 3px 0px #397f1f;
  outline: none;
}

.wordbtn{
  color: #397f1f;
  font-weight: 600;
  padding-left: 1rem;
}
.wordbtn:hover{
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
export default {
  methods: {
    change_password: async function () {
      let fd = new FormData(document.getElementById('password_change_form'))
      if (fd.get('password_old') === fd.get('password_new')) {
        this.errorMessage('輸入的舊密碼與新密碼相同。')
        return
      }
      if (fd.get('password_new') !== fd.get('password_confirm')) {
        this.errorMessage('輸入的新密碼與重新輸入的新密碼不同。')
        return
      }
      try {
        this.$emit('loading')
        await this.$store.dispatch('request', {
          method: 'post',
          route: `profile/password`,
          data: fd
        })
        this.successMessage()
      } catch (err) {
        this.errorMessage('輸入的舊密碼與現時密碼不同。')
      }
      this.$emit('loaded')
    },
    successMessage () {
      this.$message({
        showClose: true,
        message: '更改密碼成功',
        type: 'success'
      })
    },
    errorMessage (r) {
      this.$alert(r, '錯誤', {
        confirmButtonText: 'OK'
      })
    }
  }
}
</script>
